import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { getCountryCodeFromLocale } from '../../utils/consumer'
import { getPortalMigrationEnabledFromCookie } from '../../utils/convergence'
import { getPortalMigrationEnabledCountry } from '../../model/convergence'
import { useFlag, LaunchDarklyFlags } from '../useFlag'

export const usePortalMigrationEnabled = (): boolean => {
  const router = useRouter()
  const { locale } = router
  const country = getCountryCodeFromLocale(locale)

  const loginMigrationVariant = useFlag(LaunchDarklyFlags.LoginMigration, 'C')

  const isEnabled = useMemo(() => {
    const portalMigrationEnabledCountry = getPortalMigrationEnabledCountry()

    const isCountryEnabled = portalMigrationEnabledCountry.includes(country)

    if (!isCountryEnabled) {
      return false
    }

    const cookieValue = getPortalMigrationEnabledFromCookie()

    if (cookieValue) {
      return true
    }

    const isFlagA = loginMigrationVariant === 'A'

    return isFlagA
  }, [country, loginMigrationVariant])

  return isEnabled
}
